export default __webpack_public_path__ + "static/media/sch7_w640.ab176da0.jpg";